export const GA_PAGE_VIEW = 'GA_PAGE_VIEW'
export const GA_SEND_EVENT = 'GA_SEND_EVENT'
